export async function hashPassword(password) {
  const msgUint8 = new TextEncoder().encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(Math.floor(num || 0));
};

export const formatWeight = (num) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num || 0) + ' kg';
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
  }).format(amount);
};

export const calculateAverageKilos = (kilos, heads) => heads > 0 ? (kilos / heads).toFixed(2) : 0;

export const calculateAveragePrice = (total, kilos) => kilos > 0 ? (total / kilos).toFixed(2) : 0;

export const getCurrentLocalDatetime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
};

// Escape a single CSV cell. Two concerns:
//   1. Quoting: values containing commas, quotes, newlines, or carriage
//      returns get wrapped in double-quotes with internal quotes doubled.
//   2. Formula injection: spreadsheet apps execute cells beginning with
//      =, +, -, @, tab, or CR as formulas. Prefix such values with a
//      leading single quote so they're treated as text.
export const csvCell = (value) => {
  if (value == null) return '';
  let s = String(value);
  if (s.length > 0 && '=+-@\t\r'.includes(s[0])) {
    s = "'" + s;
  }
  if (/[",\n\r]/.test(s)) {
    s = '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
};

// Build a CSV string from a 2D array of header + rows. Each cell is
// passed through csvCell.
export const buildCSV = (rows) =>
  rows.map(row => row.map(csvCell).join(',')).join('\n');
